import { connect } from 'react-redux';
import UploadInvoice from '../../../../views/Finance/Spp/LaporanKeu/UploadInvoice.laporaninvoice.view';
import { getAdjustmentJournal } from '../../../../states/thunks/finance.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAdjustmentJournal: payload => dispatch(getAdjustmentJournal(payload)),
  };
}

export default connect(null, mapDispatchToProps)(UploadInvoice);
